import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IconPencil, IconTrash } from '../primitives/Icons';

interface ActionSheetProps {
  /** Conversation title shown read-only at the top of the sheet. */
  title: string;
  onRename: () => void;
  onDelete: () => void;
  onClose: () => void;
}

/**
 * Mobile-only bottom action sheet for sidebar row context actions.
 * Slides up from the bottom over a scrim; tap outside or "取消" dismisses.
 */
export function ActionSheet({ title, onRename, onDelete, onClose }: ActionSheetProps) {
  const { t } = useTranslation();

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="sheet-overlay" onClick={onClose} role="presentation">
      <div
        className="sheet"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="sheet-title">{title}</div>
        <button type="button" className="sheet-item" onClick={onRename}>
          <IconPencil />
          <span>{t('rename')}</span>
        </button>
        <button type="button" className="sheet-item sheet-danger" onClick={onDelete}>
          <IconTrash />
          <span>{t('deleteConversation')}</span>
        </button>
        <div className="sheet-divider" />
        <button type="button" className="sheet-cancel" onClick={onClose}>
          {t('cancel')}
        </button>
      </div>
    </div>
  );
}
